/**
 * The room-family booking flow's step order, shared by every flow built on the
 * `BookingFlowShell` (ADR-0026, phase 1 step 5).
 *
 * It lives in its own module (rather than inside a page) so a consumer that
 * only needs the step index — the footer CTA, a test — does not pull a whole
 * page tree in with it.
 *
 * ── Why there is only one of these ────────────────────────────────────────
 *
 * Room rental and venue reservation each declared their own copy, and the two
 * were numerically IDENTICAL: same members in the same order, differing only
 * in what member 5 was called — `payment` in room, `success` in venue. Both
 * are step 5, and which screen it renders is decided by `directBooking`, not
 * by the enum. Nothing outside the venue page ever imported the venue copy.
 *
 * The name kept is `payment`, because it is the one the shared footer
 * (`ApartmentRentalNavigateNextAction`) already imports.
 *
 * ⚠️ The step ORDER here is not the same as the `bookingFlow` array the pages
 * dispatch, which lists `bookingSummary` before `personalData`. That
 * disagreement is pre-existing and identical in both flows, so it is carried
 * across untouched rather than "tidied" — whatever depends on it depends on it
 * in both flows equally.
 */
export enum BookingCreationStep {
  locationSelection,
  apartmentSelection,
  apartmentOverview,
  personalData,
  bookingSummary,
  payment,
}
